'use strict';

var React = require('react');

/**
 * @public
 */
const PresenceContext = 
/* @__PURE__ */ React.createContext(null);

exports.PresenceContext = PresenceContext;
//# sourceMappingURL=PresenceContext.cjs.map
